var map = {
	"./365-fa-logo-extended.svg": 3056,
	"./365-logo-brand.svg": 3057,
	"./365-logo-extended.svg": 3038,
	"./365-logo-premium-gradient.svg": 3058,
	"./365-logo-premium2.svg": 2577,
	"./365-logo-premium3.svg": 2578,
	"./365-logo-sm.svg": 2008,
	"./365-logo.svg": 1965,
	"./CaretRight.svg": 3059,
	"./arrow-right.svg": 494,
	"./autosave.svg": 2009,
	"./calculator-arrow.svg": 2010,
	"./campaign-stars-rating.svg": 1604,
	"./caret-left-circle-outline.svg": 3060,
	"./caret-left-circle.svg": 499,
	"./caret-right-circle-outline.svg": 3061,
	"./caret-right-circle.svg": 500,
	"./caret-right-white.svg": 2579,
	"./caret-right.svg": 599,
	"./carret-down-flashcards.svg": 2580,
	"./carret-down.svg": 2581,
	"./certificate-badge.svg": 2011,
	"./check-campaign-auto.svg": 1966,
	"./check.svg": 3062,
	"./checkout-minus-icon.svg": 2582,
	"./checkout-plus-icon.svg": 2583,
	"./close-icon.svg": 521,
	"./coding-exercise/icon-coding-exercise-ai.svg": 2584,
	"./coding-exercise/icon-coding-exercise-collapse.svg": 2116,
	"./coding-exercise/icon-coding-exercise-scroll.svg": 2585,
	"./coding-exercise/icon-coding-exercise.svg": 2586,
	"./coding-exercise/icon-copy.svg": 3063,
	"./coding-exercise/icon-instructions.svg": 3064,
	"./coding-exercise/icon-openai.svg": 2012,
	"./coding-exercise/icon-solution-code.svg": 3065,
	"./coding-exercise/icon-student.svg": 3066,
	"./companies/campaign-logo-alphabet.svg": 555,
	"./companies/campaign-logo-amazon.svg": 556,
	"./companies/campaign-logo-bank-of-america.svg": 557,
	"./companies/campaign-logo-barclays.svg": 558,
	"./companies/campaign-logo-bnp-paribas.svg": 559,
	"./companies/campaign-logo-coca-cola.svg": 560,
	"./companies/campaign-logo-goldman-sachs.svg": 561,
	"./companies/campaign-logo-hsbc.svg": 531,
	"./companies/campaign-logo-ikea.svg": 562,
	"./companies/campaign-logo-jp-morgan.svg": 563,
	"./companies/campaign-logo-meta.svg": 564,
	"./companies/campaign-logo-morgan-stanley.svg": 565,
	"./companies/campaign-logo-oracle.svg": 566,
	"./companies/campaign-logo-pwc.svg": 567,
	"./companies/campaign-logo-walmart.svg": 568,
	"./companies/icon-amazon-auto.svg": 2587,
	"./companies/icon-apple-auto.svg": 2013,
	"./companies/icon-bank-of-america-auto.svg": 2588,
	"./companies/icon-barclays-auto.svg": 2589,
	"./companies/icon-bnp-auto.svg": 2590,
	"./companies/icon-booking-auto.svg": 2591,
	"./companies/icon-bosch-auto.svg": 2592,
	"./companies/icon-citibank-auto.svg": 2593,
	"./companies/icon-dell-auto.svg": 2594,
	"./companies/icon-deloitte-auto.svg": 2595,
	"./companies/icon-fedex-auto.svg": 2596,
	"./companies/icon-goldman-sachs-auto.svg": 2597,
	"./companies/icon-google-auto.svg": 2014,
	"./companies/icon-hsbc-auto.svg": 2598,
	"./companies/icon-humana-auto.svg": 2599,
	"./companies/icon-ikea-auto.svg": 2600,
	"./companies/icon-j-p-morgan-auto.svg": 2601,
	"./companies/icon-leowe-auto.svg": 2602,
	"./companies/icon-lindt-auto.svg": 2603,
	"./companies/icon-meta-auto.svg": 2015,
	"./companies/icon-microsoft-auto.svg": 2016,
	"./companies/icon-nissan-auto.svg": 2604,
	"./companies/icon-paypal-auto.svg": 2605,
	"./companies/icon-starbucks-auto.svg": 2606,
	"./companies/icon-tesla-auto.svg": 2607,
	"./companies/icon-ups-auto.svg": 2608,
	"./companies/icon-vanguard-auto.svg": 2609,
	"./companies/icon-virgin-media-auto.svg": 2610,
	"./companies/icon-walmart-auto.svg": 2017,
	"./companies/logo-alphabet.svg": 532,
	"./companies/logo-amazon-2.svg": 533,
	"./companies/logo-amazon.svg": 569,
	"./companies/logo-azercell.svg": 570,
	"./companies/logo-bank-of-america.svg": 571,
	"./companies/logo-barclays.svg": 572,
	"./companies/logo-bbc.svg": 573,
	"./companies/logo-bloomberg.svg": 534,
	"./companies/logo-bnp-paribas.svg": 574,
	"./companies/logo-booking.svg": 575,
	"./companies/logo-citibank.svg": 576,
	"./companies/logo-cnbc.svg": 535,
	"./companies/logo-cnbc2.svg": 577,
	"./companies/logo-coca-cola-auto.svg": 536,
	"./companies/logo-coca-cola-white.svg": 1472,
	"./companies/logo-coca-cola.svg": 578,
	"./companies/logo-deloitte.svg": 579,
	"./companies/logo-experian.svg": 580,
	"./companies/logo-facebook.svg": 581,
	"./companies/logo-forbes.svg": 537,
	"./companies/logo-g.svg": 1473,
	"./companies/logo-goldman-sachs-new.svg": 582,
	"./companies/logo-goldman-sachs.svg": 1419,
	"./companies/logo-google-new.svg": 583,
	"./companies/logo-google.svg": 584,
	"./companies/logo-h.svg": 585,
	"./companies/logo-henkel.svg": 586,
	"./companies/logo-hsbc-new.svg": 587,
	"./companies/logo-hsbc.svg": 1420,
	"./companies/logo-ikea-new.svg": 588,
	"./companies/logo-ikea.svg": 1474,
	"./companies/logo-infineon.svg": 589,
	"./companies/logo-instagram-icon.svg": 538,
	"./companies/logo-instagram.svg": 590,
	"./companies/logo-jp-morgan.svg": 591,
	"./companies/logo-jti.svg": 592,
	"./companies/logo-linkedin.svg": 593,
	"./companies/logo-meta-new.svg": 539,
	"./companies/logo-meta.svg": 1421,
	"./companies/logo-morgan-stanley-new.svg": 594,
	"./companies/logo-morgan-stanley.svg": 1422,
	"./companies/logo-netflix.svg": 1423,
	"./companies/logo-oracle.svg": 540,
	"./companies/logo-paypal.svg": 595,
	"./companies/logo-pwc-new.svg": 541,
	"./companies/logo-pwc.svg": 1475,
	"./companies/logo-spotify.svg": 1424,
	"./companies/logo-tesla.svg": 596,
	"./companies/logo-usa-today.svg": 542,
	"./companies/logo-visa.svg": 597,
	"./companies/logo-walmart.svg": 543,
	"./companies/logo-wsj.svg": 544,
	"./companies/logo-youtube.svg": 598,
	"./courses/arrow-right.svg": 1908,
	"./courses/audience-icon.svg": 1877,
	"./courses/certificate-of-achievement.svg": 1909,
	"./courses/check-icon.svg": 1878,
	"./courses/clock-colored.svg": 1456,
	"./courses/clock.svg": 1825,
	"./courses/closed-captions.svg": 1910,
	"./courses/coding-exercises.svg": 1911,
	"./courses/course-exam.svg": 1912,
	"./courses/curriculum-icon.svg": 1879,
	"./courses/downloadable-resources.svg": 1913,
	"./courses/fire.svg": 1914,
	"./courses/future-course-updates.svg": 1915,
	"./courses/hours-of-content.svg": 1916,
	"./courses/icon-book.svg": 1880,
	"./courses/icon-label-bestseller.svg": 1313,
	"./courses/icon-label-free.svg": 1314,
	"./courses/icon-label-new.svg": 1315,
	"./courses/icon-label-popular.svg": 1316,
	"./courses/icon-label-top-rated.svg": 1317,
	"./courses/icon-label-trending.svg": 1318,
	"./courses/icon-lesson-type.svg": 1826,
	"./courses/icon-people.svg": 1881,
	"./courses/icon-star.svg": 1882,
	"./courses/icon-text-lesson-type.svg": 1827,
	"./courses/instructors-icon.svg": 1883,
	"./courses/interactive-exercises-lg.svg": 1884,
	"./courses/interactive-exercises.svg": 1885,
	"./courses/medal-colored.svg": 1917,
	"./courses/medal.svg": 2575,
	"./courses/monitor-colored.svg": 1918,
	"./courses/monitor.svg": 1425,
	"./courses/overview-icon.svg": 1886,
	"./courses/play-circle.svg": 1919,
	"./courses/play.svg": 1920,
	"./courses/practical-tasks-colored.svg": 1921,
	"./courses/practical-tasks.svg": 1922,
	"./courses/projects-icon.svg": 1887,
	"./courses/q-and-a-support.svg": 1923,
	"./courses/replay.svg": 1924,
	"./courses/requirements-icon.svg": 1888,
	"./courses/reviews-icon.svg": 1889,
	"./courses/rocket-icon.svg": 1890,
	"./courses/similar-courses-icon.svg": 1891,
	"./courses/tags-icon.svg": 1892,
	"./courses/topics-icon.svg": 1893,
	"./courses/tracks-icon.svg": 1894,
	"./courses/what-you-learn.svg": 1895,
	"./courses/world-class-instructor.svg": 1925,
	"./curved-arrow.svg": 2117,
	"./ds-cm-lifetime-discount-mobile.svg": 3039,
	"./ds-cm-lifetime-discount.svg": 3040,
	"./ds-cm-lifetime-plan-mobile.svg": 3041,
	"./ds-cm-lifetime-plan.svg": 3042,
	"./ds-fw2024-free.svg": 2018,
	"./editor-js/ejs-edit.svg": 1828,
	"./editor-js/ejs-hover-icon-delete.svg": 3067,
	"./editor-js/ejs-hover-icon-move-down.svg": 3068,
	"./editor-js/ejs-hover-icon-move-up.svg": 3069,
	"./editor-js/ejs-icon-code.svg": 1926,
	"./editor-js/ejs-icon-delete.svg": 1927,
	"./editor-js/ejs-icon-equation.svg": 1928,
	"./editor-js/ejs-icon-highlight.svg": 1929,
	"./editor-js/ejs-icon-info.svg": 1930,
	"./editor-js/ejs-icon-move-down.svg": 1931,
	"./editor-js/ejs-icon-move-up.svg": 1932,
	"./editor-js/ejs-icon-spoiler.svg": 1933,
	"./editor-js/ejs-icon-text.svg": 1934,
	"./editor-js/ejs-icon-warning.svg": 1935,
	"./editor-js/link-template/article-background.svg": 3070,
	"./editor-js/link-template/bookmark-background.svg": 3071,
	"./editor-js/link-template/other-background.svg": 3072,
	"./editor-js/link-template/video-background.svg": 3073,
	"./editor-js/link-template/website-background.svg": 3074,
	"./editor-resize-handle.svg": 3075,
	"./editor/bold.svg": 3076,
	"./editor/emoji.svg": 3077,
	"./editor/image.svg": 3078,
	"./editor/italic.svg": 3079,
	"./editor/language-arrow-editor-rotate.svg": 3080,
	"./editor/language-arrow-editor.svg": 3081,
	"./editor/link.svg": 3082,
	"./editor/underline.svg": 3083,
	"./equation/icon-equation-accent-1.svg": 2118,
	"./equation/icon-equation-accent-10.svg": 2119,
	"./equation/icon-equation-accent-11.svg": 2120,
	"./equation/icon-equation-accent-12.svg": 2121,
	"./equation/icon-equation-accent-13.svg": 2122,
	"./equation/icon-equation-accent-14.svg": 2123,
	"./equation/icon-equation-accent-15.svg": 2124,
	"./equation/icon-equation-accent-16.svg": 2125,
	"./equation/icon-equation-accent-17.svg": 2126,
	"./equation/icon-equation-accent-18.svg": 2127,
	"./equation/icon-equation-accent-19.svg": 2128,
	"./equation/icon-equation-accent-2.svg": 2129,
	"./equation/icon-equation-accent-20.svg": 2130,
	"./equation/icon-equation-accent-21.svg": 2131,
	"./equation/icon-equation-accent-22.svg": 2132,
	"./equation/icon-equation-accent-3.svg": 2133,
	"./equation/icon-equation-accent-4.svg": 2134,
	"./equation/icon-equation-accent-5.svg": 2135,
	"./equation/icon-equation-accent-6.svg": 2136,
	"./equation/icon-equation-accent-7.svg": 2137,
	"./equation/icon-equation-accent-8.svg": 2138,
	"./equation/icon-equation-accent-9.svg": 2139,
	"./equation/icon-equation-accent.svg": 2140,
	"./equation/icon-equation-bracket-1.svg": 2141,
	"./equation/icon-equation-bracket-10.svg": 2142,
	"./equation/icon-equation-bracket-11.svg": 2143,
	"./equation/icon-equation-bracket-12.svg": 2144,
	"./equation/icon-equation-bracket-13.svg": 2145,
	"./equation/icon-equation-bracket-14.svg": 2146,
	"./equation/icon-equation-bracket-15.svg": 2147,
	"./equation/icon-equation-bracket-16.svg": 2148,
	"./equation/icon-equation-bracket-17.svg": 2149,
	"./equation/icon-equation-bracket-18.svg": 2150,
	"./equation/icon-equation-bracket-19.svg": 2151,
	"./equation/icon-equation-bracket-2.svg": 2152,
	"./equation/icon-equation-bracket-20.svg": 2153,
	"./equation/icon-equation-bracket-21.svg": 2154,
	"./equation/icon-equation-bracket-22.svg": 2155,
	"./equation/icon-equation-bracket-23.svg": 2156,
	"./equation/icon-equation-bracket-24.svg": 2157,
	"./equation/icon-equation-bracket-25.svg": 2158,
	"./equation/icon-equation-bracket-26.svg": 2159,
	"./equation/icon-equation-bracket-27.svg": 2160,
	"./equation/icon-equation-bracket-28.svg": 2161,
	"./equation/icon-equation-bracket-29.svg": 2162,
	"./equation/icon-equation-bracket-3.svg": 2163,
	"./equation/icon-equation-bracket-30.svg": 2164,
	"./equation/icon-equation-bracket-31.svg": 2165,
	"./equation/icon-equation-bracket-32.svg": 2166,
	"./equation/icon-equation-bracket-33.svg": 2167,
	"./equation/icon-equation-bracket-34.svg": 2168,
	"./equation/icon-equation-bracket-35.svg": 2169,
	"./equation/icon-equation-bracket-36.svg": 2170,
	"./equation/icon-equation-bracket-37.svg": 2171,
	"./equation/icon-equation-bracket-4.svg": 2172,
	"./equation/icon-equation-bracket-5.svg": 2173,
	"./equation/icon-equation-bracket-6.svg": 2174,
	"./equation/icon-equation-bracket-7.svg": 2175,
	"./equation/icon-equation-bracket-8.svg": 2176,
	"./equation/icon-equation-bracket-9.svg": 2177,
	"./equation/icon-equation-bracket.svg": 2178,
	"./equation/icon-equation-caps-lock-2.svg": 2179,
	"./equation/icon-equation-caps-lock.svg": 2180,
	"./equation/icon-equation-fraction-1.svg": 2181,
	"./equation/icon-equation-fraction-2.svg": 2182,
	"./equation/icon-equation-fraction-3.svg": 2183,
	"./equation/icon-equation-fraction-4.svg": 2184,
	"./equation/icon-equation-fraction-5.svg": 2185,
	"./equation/icon-equation-fraction-6.svg": 2186,
	"./equation/icon-equation-fraction-7.svg": 2187,
	"./equation/icon-equation-fraction-8.svg": 2188,
	"./equation/icon-equation-fraction.svg": 2189,
	"./equation/icon-equation-function-1.svg": 2190,
	"./equation/icon-equation-function-10.svg": 2191,
	"./equation/icon-equation-function-11.svg": 2192,
	"./equation/icon-equation-function-12.svg": 2193,
	"./equation/icon-equation-function-13.svg": 2194,
	"./equation/icon-equation-function-14.svg": 2195,
	"./equation/icon-equation-function-15.svg": 2196,
	"./equation/icon-equation-function-16.svg": 2197,
	"./equation/icon-equation-function-2.svg": 2198,
	"./equation/icon-equation-function-3.svg": 2199,
	"./equation/icon-equation-function-4.svg": 2200,
	"./equation/icon-equation-function-5.svg": 2201,
	"./equation/icon-equation-function-6.svg": 2202,
	"./equation/icon-equation-function-7.svg": 2203,
	"./equation/icon-equation-function-8.svg": 2204,
	"./equation/icon-equation-function-9.svg": 2205,
	"./equation/icon-equation-function.svg": 2206,
	"./equation/icon-equation-integral-1.svg": 2207,
	"./equation/icon-equation-integral-10.svg": 2208,
	"./equation/icon-equation-integral-11.svg": 2209,
	"./equation/icon-equation-integral-12.svg": 2210,
	"./equation/icon-equation-integral-13.svg": 2211,
	"./equation/icon-equation-integral-14.svg": 2212,
	"./equation/icon-equation-integral-15.svg": 2213,
	"./equation/icon-equation-integral-16.svg": 2214,
	"./equation/icon-equation-integral-17.svg": 2215,
	"./equation/icon-equation-integral-2.svg": 2216,
	"./equation/icon-equation-integral-3.svg": 2217,
	"./equation/icon-equation-integral-4.svg": 2218,
	"./equation/icon-equation-integral-5.svg": 2219,
	"./equation/icon-equation-integral-6.svg": 2220,
	"./equation/icon-equation-integral-7.svg": 2221,
	"./equation/icon-equation-integral-8.svg": 2222,
	"./equation/icon-equation-integral-9.svg": 2223,
	"./equation/icon-equation-integral.svg": 2224,
	"./equation/icon-equation-large-operator-1.svg": 2225,
	"./equation/icon-equation-large-operator-2.svg": 2226,
	"./equation/icon-equation-large-operator-3.svg": 2227,
	"./equation/icon-equation-large-operator-4.svg": 2228,
	"./equation/icon-equation-large-operator-5.svg": 2229,
	"./equation/icon-equation-large-operator-6.svg": 2230,
	"./equation/icon-equation-large-operator.svg": 2231,
	"./equation/icon-equation-limit-1.svg": 2232,
	"./equation/icon-equation-limit-2.svg": 2233,
	"./equation/icon-equation-limit-3.svg": 2234,
	"./equation/icon-equation-limit-4.svg": 2235,
	"./equation/icon-equation-limit-5.svg": 2236,
	"./equation/icon-equation-limit-6.svg": 2237,
	"./equation/icon-equation-limit-7.svg": 2238,
	"./equation/icon-equation-limit.svg": 2239,
	"./equation/icon-equation-matrix-1.svg": 2240,
	"./equation/icon-equation-matrix-2.svg": 2241,
	"./equation/icon-equation-matrix-3.svg": 2242,
	"./equation/icon-equation-matrix-4.svg": 2243,
	"./equation/icon-equation-matrix-5.svg": 2244,
	"./equation/icon-equation-matrix-6.svg": 2245,
	"./equation/icon-equation-matrix.svg": 2246,
	"./equation/icon-equation-numbers.svg": 2247,
	"./equation/icon-equation-operator-1.svg": 2248,
	"./equation/icon-equation-operator-10.svg": 2249,
	"./equation/icon-equation-operator-11.svg": 2250,
	"./equation/icon-equation-operator-12.svg": 2251,
	"./equation/icon-equation-operator-13.svg": 2252,
	"./equation/icon-equation-operator-14.svg": 2253,
	"./equation/icon-equation-operator-15.svg": 2254,
	"./equation/icon-equation-operator-16.svg": 2255,
	"./equation/icon-equation-operator-17.svg": 2256,
	"./equation/icon-equation-operator-18.svg": 2257,
	"./equation/icon-equation-operator-19.svg": 2258,
	"./equation/icon-equation-operator-2.svg": 2259,
	"./equation/icon-equation-operator-3.svg": 2260,
	"./equation/icon-equation-operator-4.svg": 2261,
	"./equation/icon-equation-operator-5.svg": 2262,
	"./equation/icon-equation-operator-6.svg": 2263,
	"./equation/icon-equation-operator-7.svg": 2264,
	"./equation/icon-equation-operator-8.svg": 2265,
	"./equation/icon-equation-operator-9.svg": 2266,
	"./equation/icon-equation-operator.svg": 2267,
	"./equation/icon-equation-radical-1.svg": 2268,
	"./equation/icon-equation-radical-2.svg": 2269,
	"./equation/icon-equation-radical.svg": 2270,
	"./equation/icon-equation-script-1.svg": 2271,
	"./equation/icon-equation-script-2.svg": 2272,
	"./equation/icon-equation-script-3.svg": 2273,
	"./equation/icon-equation-script-4.svg": 2274,
	"./equation/icon-equation-script.svg": 2275,
	"./equation/icon-equation-symbol-1.svg": 2276,
	"./equation/icon-equation-symbol-10.svg": 2277,
	"./equation/icon-equation-symbol-100.svg": 2278,
	"./equation/icon-equation-symbol-101.svg": 2279,
	"./equation/icon-equation-symbol-102.svg": 2280,
	"./equation/icon-equation-symbol-103.svg": 2281,
	"./equation/icon-equation-symbol-104.svg": 2282,
	"./equation/icon-equation-symbol-105.svg": 2283,
	"./equation/icon-equation-symbol-106.svg": 2284,
	"./equation/icon-equation-symbol-107.svg": 2285,
	"./equation/icon-equation-symbol-108.svg": 2286,
	"./equation/icon-equation-symbol-109.svg": 2287,
	"./equation/icon-equation-symbol-11.svg": 2288,
	"./equation/icon-equation-symbol-110.svg": 2289,
	"./equation/icon-equation-symbol-111.svg": 2290,
	"./equation/icon-equation-symbol-112.svg": 2291,
	"./equation/icon-equation-symbol-113.svg": 2292,
	"./equation/icon-equation-symbol-114.svg": 2293,
	"./equation/icon-equation-symbol-115.svg": 2294,
	"./equation/icon-equation-symbol-116.svg": 2295,
	"./equation/icon-equation-symbol-117.svg": 2296,
	"./equation/icon-equation-symbol-118.svg": 2297,
	"./equation/icon-equation-symbol-119.svg": 2298,
	"./equation/icon-equation-symbol-12.svg": 2299,
	"./equation/icon-equation-symbol-120.svg": 2300,
	"./equation/icon-equation-symbol-121.svg": 2301,
	"./equation/icon-equation-symbol-122.svg": 2302,
	"./equation/icon-equation-symbol-123.svg": 2303,
	"./equation/icon-equation-symbol-124.svg": 2304,
	"./equation/icon-equation-symbol-125.svg": 2305,
	"./equation/icon-equation-symbol-126.svg": 2306,
	"./equation/icon-equation-symbol-127.svg": 2307,
	"./equation/icon-equation-symbol-128.svg": 2308,
	"./equation/icon-equation-symbol-129.svg": 2309,
	"./equation/icon-equation-symbol-13.svg": 2310,
	"./equation/icon-equation-symbol-130.svg": 2311,
	"./equation/icon-equation-symbol-131.svg": 2312,
	"./equation/icon-equation-symbol-132.svg": 2313,
	"./equation/icon-equation-symbol-133.svg": 2314,
	"./equation/icon-equation-symbol-134.svg": 2315,
	"./equation/icon-equation-symbol-135.svg": 2316,
	"./equation/icon-equation-symbol-136.svg": 2317,
	"./equation/icon-equation-symbol-137.svg": 2318,
	"./equation/icon-equation-symbol-138.svg": 2319,
	"./equation/icon-equation-symbol-139.svg": 2320,
	"./equation/icon-equation-symbol-14.svg": 2321,
	"./equation/icon-equation-symbol-140.svg": 2322,
	"./equation/icon-equation-symbol-141.svg": 2323,
	"./equation/icon-equation-symbol-142.svg": 2324,
	"./equation/icon-equation-symbol-143.svg": 2325,
	"./equation/icon-equation-symbol-144.svg": 2326,
	"./equation/icon-equation-symbol-145.svg": 2327,
	"./equation/icon-equation-symbol-146.svg": 2328,
	"./equation/icon-equation-symbol-147.svg": 2329,
	"./equation/icon-equation-symbol-148.svg": 2330,
	"./equation/icon-equation-symbol-149.svg": 2331,
	"./equation/icon-equation-symbol-15.svg": 2332,
	"./equation/icon-equation-symbol-150.svg": 2333,
	"./equation/icon-equation-symbol-151.svg": 2334,
	"./equation/icon-equation-symbol-152.svg": 2335,
	"./equation/icon-equation-symbol-153.svg": 2336,
	"./equation/icon-equation-symbol-154.svg": 2337,
	"./equation/icon-equation-symbol-155.svg": 2338,
	"./equation/icon-equation-symbol-156.svg": 2339,
	"./equation/icon-equation-symbol-157.svg": 2340,
	"./equation/icon-equation-symbol-158.svg": 2341,
	"./equation/icon-equation-symbol-159.svg": 2342,
	"./equation/icon-equation-symbol-16.svg": 2343,
	"./equation/icon-equation-symbol-160.svg": 2344,
	"./equation/icon-equation-symbol-161.svg": 2345,
	"./equation/icon-equation-symbol-162.svg": 2346,
	"./equation/icon-equation-symbol-163.svg": 2347,
	"./equation/icon-equation-symbol-164.svg": 2348,
	"./equation/icon-equation-symbol-165.svg": 2349,
	"./equation/icon-equation-symbol-166.svg": 2350,
	"./equation/icon-equation-symbol-167.svg": 2351,
	"./equation/icon-equation-symbol-168.svg": 2352,
	"./equation/icon-equation-symbol-169.svg": 2353,
	"./equation/icon-equation-symbol-17.svg": 2354,
	"./equation/icon-equation-symbol-170.svg": 2355,
	"./equation/icon-equation-symbol-171.svg": 2356,
	"./equation/icon-equation-symbol-172.svg": 2357,
	"./equation/icon-equation-symbol-173.svg": 2358,
	"./equation/icon-equation-symbol-174.svg": 2359,
	"./equation/icon-equation-symbol-175.svg": 2360,
	"./equation/icon-equation-symbol-176.svg": 2361,
	"./equation/icon-equation-symbol-177.svg": 2362,
	"./equation/icon-equation-symbol-178.svg": 2363,
	"./equation/icon-equation-symbol-179.svg": 2364,
	"./equation/icon-equation-symbol-18.svg": 2365,
	"./equation/icon-equation-symbol-180.svg": 2366,
	"./equation/icon-equation-symbol-181.svg": 2367,
	"./equation/icon-equation-symbol-182.svg": 2368,
	"./equation/icon-equation-symbol-183.svg": 2369,
	"./equation/icon-equation-symbol-184.svg": 2370,
	"./equation/icon-equation-symbol-185.svg": 2371,
	"./equation/icon-equation-symbol-186.svg": 2372,
	"./equation/icon-equation-symbol-187.svg": 2373,
	"./equation/icon-equation-symbol-188.svg": 2374,
	"./equation/icon-equation-symbol-189.svg": 2375,
	"./equation/icon-equation-symbol-19.svg": 2376,
	"./equation/icon-equation-symbol-190.svg": 2377,
	"./equation/icon-equation-symbol-191.svg": 2378,
	"./equation/icon-equation-symbol-192.svg": 2379,
	"./equation/icon-equation-symbol-193.svg": 2380,
	"./equation/icon-equation-symbol-194.svg": 2381,
	"./equation/icon-equation-symbol-195.svg": 2382,
	"./equation/icon-equation-symbol-196.svg": 2383,
	"./equation/icon-equation-symbol-197.svg": 2384,
	"./equation/icon-equation-symbol-198.svg": 2385,
	"./equation/icon-equation-symbol-199.svg": 2386,
	"./equation/icon-equation-symbol-2.svg": 2387,
	"./equation/icon-equation-symbol-20.svg": 2388,
	"./equation/icon-equation-symbol-200.svg": 2389,
	"./equation/icon-equation-symbol-201.svg": 2390,
	"./equation/icon-equation-symbol-202.svg": 2391,
	"./equation/icon-equation-symbol-203.svg": 2392,
	"./equation/icon-equation-symbol-204.svg": 2393,
	"./equation/icon-equation-symbol-205.svg": 2394,
	"./equation/icon-equation-symbol-206.svg": 2395,
	"./equation/icon-equation-symbol-207.svg": 2396,
	"./equation/icon-equation-symbol-208.svg": 2397,
	"./equation/icon-equation-symbol-209.svg": 2398,
	"./equation/icon-equation-symbol-21.svg": 2399,
	"./equation/icon-equation-symbol-210.svg": 2400,
	"./equation/icon-equation-symbol-211.svg": 2401,
	"./equation/icon-equation-symbol-212.svg": 2402,
	"./equation/icon-equation-symbol-213.svg": 2403,
	"./equation/icon-equation-symbol-214.svg": 2404,
	"./equation/icon-equation-symbol-215.svg": 2405,
	"./equation/icon-equation-symbol-216.svg": 2406,
	"./equation/icon-equation-symbol-217.svg": 2407,
	"./equation/icon-equation-symbol-218.svg": 2408,
	"./equation/icon-equation-symbol-219.svg": 2409,
	"./equation/icon-equation-symbol-22.svg": 2410,
	"./equation/icon-equation-symbol-220.svg": 2411,
	"./equation/icon-equation-symbol-221.svg": 2412,
	"./equation/icon-equation-symbol-222.svg": 2413,
	"./equation/icon-equation-symbol-223.svg": 2414,
	"./equation/icon-equation-symbol-224.svg": 2415,
	"./equation/icon-equation-symbol-225.svg": 2416,
	"./equation/icon-equation-symbol-226.svg": 2417,
	"./equation/icon-equation-symbol-227.svg": 2418,
	"./equation/icon-equation-symbol-228.svg": 2419,
	"./equation/icon-equation-symbol-229.svg": 2420,
	"./equation/icon-equation-symbol-23.svg": 2421,
	"./equation/icon-equation-symbol-230.svg": 2422,
	"./equation/icon-equation-symbol-231.svg": 2423,
	"./equation/icon-equation-symbol-232.svg": 2424,
	"./equation/icon-equation-symbol-233.svg": 2425,
	"./equation/icon-equation-symbol-234.svg": 2426,
	"./equation/icon-equation-symbol-235.svg": 2427,
	"./equation/icon-equation-symbol-236.svg": 2428,
	"./equation/icon-equation-symbol-237.svg": 2429,
	"./equation/icon-equation-symbol-238.svg": 2430,
	"./equation/icon-equation-symbol-239.svg": 2431,
	"./equation/icon-equation-symbol-24.svg": 2432,
	"./equation/icon-equation-symbol-240.svg": 2433,
	"./equation/icon-equation-symbol-241.svg": 2434,
	"./equation/icon-equation-symbol-242.svg": 2435,
	"./equation/icon-equation-symbol-243.svg": 2436,
	"./equation/icon-equation-symbol-244.svg": 2437,
	"./equation/icon-equation-symbol-245.svg": 2438,
	"./equation/icon-equation-symbol-246.svg": 2439,
	"./equation/icon-equation-symbol-247.svg": 2440,
	"./equation/icon-equation-symbol-248.svg": 2441,
	"./equation/icon-equation-symbol-249.svg": 2442,
	"./equation/icon-equation-symbol-25.svg": 2443,
	"./equation/icon-equation-symbol-250.svg": 2444,
	"./equation/icon-equation-symbol-251.svg": 2445,
	"./equation/icon-equation-symbol-252.svg": 2446,
	"./equation/icon-equation-symbol-253.svg": 2447,
	"./equation/icon-equation-symbol-254.svg": 2448,
	"./equation/icon-equation-symbol-255.svg": 2449,
	"./equation/icon-equation-symbol-256.svg": 2450,
	"./equation/icon-equation-symbol-257.svg": 2451,
	"./equation/icon-equation-symbol-258.svg": 2452,
	"./equation/icon-equation-symbol-259.svg": 2453,
	"./equation/icon-equation-symbol-26.svg": 2454,
	"./equation/icon-equation-symbol-260.svg": 2455,
	"./equation/icon-equation-symbol-261.svg": 2456,
	"./equation/icon-equation-symbol-262.svg": 2457,
	"./equation/icon-equation-symbol-263.svg": 2458,
	"./equation/icon-equation-symbol-264.svg": 2459,
	"./equation/icon-equation-symbol-265.svg": 2460,
	"./equation/icon-equation-symbol-266.svg": 2461,
	"./equation/icon-equation-symbol-267.svg": 2462,
	"./equation/icon-equation-symbol-268.svg": 2463,
	"./equation/icon-equation-symbol-269.svg": 2464,
	"./equation/icon-equation-symbol-27.svg": 2465,
	"./equation/icon-equation-symbol-270.svg": 2466,
	"./equation/icon-equation-symbol-271.svg": 2467,
	"./equation/icon-equation-symbol-272.svg": 2468,
	"./equation/icon-equation-symbol-273.svg": 2469,
	"./equation/icon-equation-symbol-274.svg": 2470,
	"./equation/icon-equation-symbol-275.svg": 2471,
	"./equation/icon-equation-symbol-276.svg": 2472,
	"./equation/icon-equation-symbol-28.svg": 2473,
	"./equation/icon-equation-symbol-29.svg": 2474,
	"./equation/icon-equation-symbol-3.svg": 2475,
	"./equation/icon-equation-symbol-30.svg": 2476,
	"./equation/icon-equation-symbol-31.svg": 2477,
	"./equation/icon-equation-symbol-32.svg": 2478,
	"./equation/icon-equation-symbol-33.svg": 2479,
	"./equation/icon-equation-symbol-34.svg": 2480,
	"./equation/icon-equation-symbol-35.svg": 2481,
	"./equation/icon-equation-symbol-36.svg": 2482,
	"./equation/icon-equation-symbol-37.svg": 2483,
	"./equation/icon-equation-symbol-38.svg": 2484,
	"./equation/icon-equation-symbol-39.svg": 2485,
	"./equation/icon-equation-symbol-4.svg": 2486,
	"./equation/icon-equation-symbol-40.svg": 2487,
	"./equation/icon-equation-symbol-41.svg": 2488,
	"./equation/icon-equation-symbol-42.svg": 2489,
	"./equation/icon-equation-symbol-43.svg": 2490,
	"./equation/icon-equation-symbol-44.svg": 2491,
	"./equation/icon-equation-symbol-45.svg": 2492,
	"./equation/icon-equation-symbol-46.svg": 2493,
	"./equation/icon-equation-symbol-47.svg": 2494,
	"./equation/icon-equation-symbol-48.svg": 2495,
	"./equation/icon-equation-symbol-49.svg": 2496,
	"./equation/icon-equation-symbol-5.svg": 2497,
	"./equation/icon-equation-symbol-50.svg": 2498,
	"./equation/icon-equation-symbol-51.svg": 2499,
	"./equation/icon-equation-symbol-52.svg": 2500,
	"./equation/icon-equation-symbol-53.svg": 2501,
	"./equation/icon-equation-symbol-54.svg": 2502,
	"./equation/icon-equation-symbol-55.svg": 2503,
	"./equation/icon-equation-symbol-56.svg": 2504,
	"./equation/icon-equation-symbol-57.svg": 2505,
	"./equation/icon-equation-symbol-58.svg": 2506,
	"./equation/icon-equation-symbol-59.svg": 2507,
	"./equation/icon-equation-symbol-6.svg": 2508,
	"./equation/icon-equation-symbol-60.svg": 2509,
	"./equation/icon-equation-symbol-61.svg": 2510,
	"./equation/icon-equation-symbol-62.svg": 2511,
	"./equation/icon-equation-symbol-63.svg": 2512,
	"./equation/icon-equation-symbol-64.svg": 2513,
	"./equation/icon-equation-symbol-65.svg": 2514,
	"./equation/icon-equation-symbol-66.svg": 2515,
	"./equation/icon-equation-symbol-67.svg": 2516,
	"./equation/icon-equation-symbol-68.svg": 2517,
	"./equation/icon-equation-symbol-69.svg": 2518,
	"./equation/icon-equation-symbol-7.svg": 2519,
	"./equation/icon-equation-symbol-70.svg": 2520,
	"./equation/icon-equation-symbol-71.svg": 2521,
	"./equation/icon-equation-symbol-72.svg": 2522,
	"./equation/icon-equation-symbol-73.svg": 2523,
	"./equation/icon-equation-symbol-74.svg": 2524,
	"./equation/icon-equation-symbol-75.svg": 2525,
	"./equation/icon-equation-symbol-76.svg": 2526,
	"./equation/icon-equation-symbol-77.svg": 2527,
	"./equation/icon-equation-symbol-78.svg": 2528,
	"./equation/icon-equation-symbol-79.svg": 2529,
	"./equation/icon-equation-symbol-8.svg": 2530,
	"./equation/icon-equation-symbol-80.svg": 2531,
	"./equation/icon-equation-symbol-81.svg": 2532,
	"./equation/icon-equation-symbol-82.svg": 2533,
	"./equation/icon-equation-symbol-83.svg": 2534,
	"./equation/icon-equation-symbol-84.svg": 2535,
	"./equation/icon-equation-symbol-85.svg": 2536,
	"./equation/icon-equation-symbol-86.svg": 2537,
	"./equation/icon-equation-symbol-87.svg": 2538,
	"./equation/icon-equation-symbol-88.svg": 2539,
	"./equation/icon-equation-symbol-89.svg": 2540,
	"./equation/icon-equation-symbol-9.svg": 2541,
	"./equation/icon-equation-symbol-90.svg": 2542,
	"./equation/icon-equation-symbol-91.svg": 2543,
	"./equation/icon-equation-symbol-92.svg": 2544,
	"./equation/icon-equation-symbol-93.svg": 2545,
	"./equation/icon-equation-symbol-94.svg": 2546,
	"./equation/icon-equation-symbol-95.svg": 2547,
	"./equation/icon-equation-symbol-96.svg": 2548,
	"./equation/icon-equation-symbol-97.svg": 2549,
	"./equation/icon-equation-symbol-98.svg": 2550,
	"./equation/icon-equation-symbol-99.svg": 2551,
	"./equation/icon-equation-symbol.svg": 2552,
	"./equation/icon-menu-accent.svg": 2611,
	"./equation/icon-menu-arrows.svg": 2612,
	"./equation/icon-menu-basic-math.svg": 2613,
	"./equation/icon-menu-bracket.svg": 2614,
	"./equation/icon-menu-fraction.svg": 2615,
	"./equation/icon-menu-function.svg": 2616,
	"./equation/icon-menu-geometry.svg": 2617,
	"./equation/icon-menu-greek.svg": 2618,
	"./equation/icon-menu-integral.svg": 2619,
	"./equation/icon-menu-large-operator.svg": 2620,
	"./equation/icon-menu-letter-like.svg": 2621,
	"./equation/icon-menu-letters.svg": 2622,
	"./equation/icon-menu-limit.svg": 2623,
	"./equation/icon-menu-matrix.svg": 2624,
	"./equation/icon-menu-operator.svg": 2625,
	"./equation/icon-menu-operators.svg": 2626,
	"./equation/icon-menu-radical.svg": 2627,
	"./equation/icon-menu-script.svg": 2628,
	"./equation/icon-menu-text.svg": 2629,
	"./exams/arrow.svg": 1829,
	"./exams/correct-answer.svg": 2630,
	"./exams/excel.svg": 3084,
	"./exams/icon-star.svg": 3085,
	"./exams/incorrect-answer.svg": 2631,
	"./exams/pdf.svg": 3086,
	"./exams/python.svg": 3087,
	"./exams/unknown.svg": 1799,
	"./exercise/blank-typing.svg": 1936,
	"./exercise/blank.svg": 1937,
	"./exercise/category.svg": 1938,
	"./exercise/matrix.svg": 1939,
	"./exercise/multiple-choice.svg": 1940,
	"./exercise/order.svg": 1941,
	"./exercise/single-choice.svg": 1942,
	"./exercise/true-false.svg": 1943,
	"./eye-closed-lash.svg": 3043,
	"./eye-closed.svg": 3088,
	"./eye-opened.svg": 3089,
	"./eye.svg": 2632,
	"./fa-cm-lifetime-discount-mobile.svg": 3044,
	"./fa-cm-lifetime-discount.svg": 3045,
	"./fa-cm-lifetime-plan-mobile.svg": 3046,
	"./fa-cm-lifetime-plan.svg": 3047,
	"./fa-fw2024-free.svg": 2019,
	"./fa/fa-icon-checked-blue.svg": 3090,
	"./flashcards/browse-deck.svg": 2020,
	"./flashcards/click-hand.svg": 2633,
	"./flashcards/load-arrow.svg": 2021,
	"./flashcards/reload-deck.svg": 2022,
	"./flashcards/restart-review.svg": 3091,
	"./flashcards/review-small-eye.svg": 2634,
	"./flashcards/send-result.svg": 2635,
	"./flashcards/take-test.svg": 2023,
	"./flashcards/white-left-arrow.svg": 2636,
	"./gfx-certificate-circle.svg": 3092,
	"./gfx-certificate-excel.svg": 3093,
	"./gfx-certificate-git.svg": 3094,
	"./gfx-certificate-powerbi.svg": 3095,
	"./gfx-certificate-python.svg": 3096,
	"./gfx-certificate-r.svg": 3097,
	"./gfx-certificate-tableau.svg": 3098,
	"./gfx-certificate-theory.svg": 3099,
	"./gfx-hats-left.svg": 3100,
	"./gfx-hats-right.svg": 3101,
	"./icon-404-lms-courses.svg": 2637,
	"./icon-404-lms-practice.svg": 2638,
	"./icon-404-lms-qa.svg": 2639,
	"./icon-admin-difficulty-0.svg": 1457,
	"./icon-admin-difficulty-1.svg": 1458,
	"./icon-admin-difficulty-2.svg": 1459,
	"./icon-admin-info.svg": 1460,
	"./icon-alert.svg": 2640,
	"./icon-arrow-back.svg": 522,
	"./icon-arrow-blue.svg": 2641,
	"./icon-arrow-down-resizable.svg": 1830,
	"./icon-arrow-down.svg": 1831,
	"./icon-arrow-dropdown-down.svg": 2553,
	"./icon-arrow-dropdown.svg": 2024,
	"./icon-arrow-expand.svg": 1630,
	"./icon-arrow-gray.svg": 1605,
	"./icon-arrow-left.svg": 1326,
	"./icon-arrow-next-new.svg": 2025,
	"./icon-arrow-prev-new.svg": 2026,
	"./icon-arrow-right.svg": 1800,
	"./icon-arrow-up.svg": 1967,
	"./icon-arrow.svg": 1832,
	"./icon-assignment.svg": 2642,
	"./icon-audience-1.svg": 2027,
	"./icon-audience-2.svg": 2028,
	"./icon-audience-3.svg": 2029,
	"./icon-back.svg": 1968,
	"./icon-backspace.svg": 2554,
	"./icon-basket.svg": 2030,
	"./icon-berkeley-uni.svg": 2031,
	"./icon-bin.svg": 2032,
	"./icon-black-filled-arrow.svg": 2643,
	"./icon-bug.svg": 2555,
	"./icon-bulb.svg": 2644,
	"./icon-career-track.svg": 2033,
	"./icon-certificate.svg": 2034,
	"./icon-certificates.svg": 2645,
	"./icon-check-blue-bold.svg": 2646,
	"./icon-check-circle.svg": 1801,
	"./icon-check-extreme-fucsia.svg": 2647,
	"./icon-check-list.svg": 2648,
	"./icon-check-projects.svg": 1802,
	"./icon-check.svg": 2035,
	"./icon-checkbox.svg": 2649,
	"./icon-checked-accent-light-3.svg": 2650,
	"./icon-checked-bf.svg": 2651,
	"./icon-checked-blue.svg": 2652,
	"./icon-checked-cm.svg": 2653,
	"./icon-checked-ds-accent.svg": 2654,
	"./icon-checked-extreme-blue-2.svg": 2655,
	"./icon-checked-extreme-magenta.svg": 2656,
	"./icon-checked-extreme-orange.svg": 2657,
	"./icon-checked-extreme-red.svg": 2658,
	"./icon-checked-mw.svg": 2659,
	"./icon-checked-purple.svg": 2660,
	"./icon-checked-tyf.svg": 2661,
	"./icon-checked-yellow-bold.svg": 2662,
	"./icon-checked-yellow.svg": 2663,
	"./icon-checked.svg": 2664,
	"./icon-checkmark.svg": 2665,
	"./icon-chicago-uni.svg": 2036,
	"./icon-circle-check.svg": 2666,
	"./icon-clear-filters.svg": 2667,
	"./icon-clock-colored.svg": 2668,
	"./icon-clock.svg": 2037,
	"./icon-close.svg": 492,
	"./icon-closemark.svg": 2669,
	"./icon-clp-trash.svg": 639,
	"./icon-code.svg": 2670,
	"./icon-coding-exercise-type.svg": 2671,
	"./icon-colored-google.svg": 2672,
	"./icon-colored-linkedin-fill.svg": 2673,
	"./icon-columbia-uni.svg": 2038,
	"./icon-comment.svg": 1833,
	"./icon-complete-program.svg": 2674,
	"./icon-completed.svg": 2675,
	"./icon-copy-text.svg": 2676,
	"./icon-copy.svg": 1944,
	"./icon-course-banner.svg": 2677,
	"./icon-course-content.svg": 1834,
	"./icon-course-exam-type.svg": 2678,
	"./icon-courses.svg": 2679,
	"./icon-curriculum-review-comment-resolved.svg": 2680,
	"./icon-curriculum-review-comment.svg": 2681,
	"./icon-curriculum-validation-error.svg": 2682,
	"./icon-description-type.svg": 2683,
	"./icon-difficulty-advanced-2.svg": 1969,
	"./icon-difficulty-advanced.svg": 2039,
	"./icon-difficulty-beginner-2.svg": 1970,
	"./icon-difficulty-beginner.svg": 2040,
	"./icon-difficulty-intermediate-2.svg": 1971,
	"./icon-difficulty-intermediate.svg": 2041,
	"./icon-down-arrow.svg": 2042,
	"./icon-download-arrow.svg": 2684,
	"./icon-download-sm.svg": 2685,
	"./icon-download.svg": 2686,
	"./icon-download2.svg": 2556,
	"./icon-drag-dots.svg": 2687,
	"./icon-editor-bold.svg": 2688,
	"./icon-editor-code.svg": 2689,
	"./icon-editor-codeblock.svg": 2690,
	"./icon-editor-emoji.svg": 2691,
	"./icon-editor-image.svg": 2692,
	"./icon-editor-italic.svg": 2693,
	"./icon-editor-link.svg": 2694,
	"./icon-editor-strike.svg": 2695,
	"./icon-empty-folder.svg": 2696,
	"./icon-enter.svg": 2557,
	"./icon-exam-clock.svg": 1631,
	"./icon-exam-download.svg": 2697,
	"./icon-exam-flag.svg": 1596,
	"./icon-exam-question-type.svg": 2698,
	"./icon-exam-question.svg": 1835,
	"./icon-exam-share-result.svg": 2699,
	"./icon-exam-summary-type.svg": 2700,
	"./icon-exam-warning.svg": 1322,
	"./icon-exams-subtract.svg": 2558,
	"./icon-exclamation-red.svg": 1836,
	"./icon-exclamation.svg": 1972,
	"./icon-exercise-type.svg": 2701,
	"./icon-exit.svg": 2702,
	"./icon-eye.svg": 2559,
	"./icon-facebook-white.svg": 2703,
	"./icon-facebook.svg": 2704,
	"./icon-faq-expand.svg": 714,
	"./icon-fb.svg": 1945,
	"./icon-film.svg": 1946,
	"./icon-filter-sort.svg": 1896,
	"./icon-filter.svg": 1897,
	"./icon-flashcards-arrow.svg": 2043,
	"./icon-header-back-arrow.svg": 1947,
	"./icon-help.svg": 2705,
	"./icon-home.svg": 2706,
	"./icon-info.svg": 519,
	"./icon-inlinecode.svg": 2707,
	"./icon-iphone.svg": 1948,
	"./icon-language.svg": 2044,
	"./icon-laptop.svg": 1949,
	"./icon-latex.svg": 2560,
	"./icon-learn.svg": 2045,
	"./icon-lesson-locked.svg": 2708,
	"./icon-lesson-text-type.svg": 1950,
	"./icon-lesson-type.svg": 2709,
	"./icon-library-badge-advanced.svg": 1837,
	"./icon-library-badge-beginner.svg": 1838,
	"./icon-library-badge-intermediate.svg": 1839,
	"./icon-lightbulb.svg": 1803,
	"./icon-link.svg": 2710,
	"./icon-linkedin-white.svg": 2711,
	"./icon-linkedin.svg": 1951,
	"./icon-locked.svg": 1907,
	"./icon-mail.svg": 513,
	"./icon-mathview.svg": 2561,
	"./icon-menu-arrow.svg": 2712,
	"./icon-menu-collapse.svg": 2562,
	"./icon-mobile-filter.svg": 2713,
	"./icon-monitor.svg": 1952,
	"./icon-newsfeed-comment.svg": 2714,
	"./icon-newsfeed-edit.svg": 2715,
	"./icon-newsfeed-learners.svg": 2716,
	"./icon-newsfeed-like.svg": 2717,
	"./icon-newsfeed-remove.svg": 2718,
	"./icon-newsfeed-report.svg": 2719,
	"./icon-newsfeed-snooze.svg": 2720,
	"./icon-newsfeed-trophy.svg": 2721,
	"./icon-notifications-bell.svg": 2722,
	"./icon-pencil-nofill.svg": 2723,
	"./icon-pencil-small-edit.svg": 2724,
	"./icon-pencil.svg": 2046,
	"./icon-penn-uni.svg": 2047,
	"./icon-people.svg": 1840,
	"./icon-photo.svg": 2725,
	"./icon-pin.svg": 1426,
	"./icon-play-accent.svg": 2048,
	"./icon-play-active.svg": 2726,
	"./icon-play-circle.svg": 1841,
	"./icon-play.svg": 2727,
	"./icon-plus-gray-fill.svg": 1327,
	"./icon-plus-in-square.svg": 1842,
	"./icon-plus.svg": 1843,
	"./icon-practice-exam-type.svg": 2728,
	"./icon-practice.svg": 2729,
	"./icon-price.svg": 2049,
	"./icon-pricing-arrow-down.svg": 2050,
	"./icon-pricing-badge.svg": 2051,
	"./icon-pricing-check.svg": 2052,
	"./icon-princeton-uni.svg": 2053,
	"./icon-project-content.svg": 2054,
	"./icon-project-featured.svg": 2055,
	"./icon-project-files.svg": 1973,
	"./icon-project-related-courses.svg": 2056,
	"./icon-project-solution-files.svg": 2057,
	"./icon-project-topics.svg": 2058,
	"./icon-project-type.svg": 2730,
	"./icon-project.svg": 2731,
	"./icon-qa-ask.svg": 2732,
	"./icon-qa-delete-answer.svg": 2733,
	"./icon-qa-diamond.svg": 2734,
	"./icon-qa-edit-answer.svg": 2735,
	"./icon-qa-ellipsis-v.svg": 2059,
	"./icon-qa-follow.svg": 2060,
	"./icon-qa-followed.svg": 2736,
	"./icon-qa-glasses.svg": 2737,
	"./icon-qa-magnifier.svg": 2738,
	"./icon-qa-mark.svg": 2061,
	"./icon-qa-report.svg": 2739,
	"./icon-qa-resolve.svg": 2062,
	"./icon-qa-unassign.svg": 2063,
	"./icon-qa.svg": 2740,
	"./icon-question-mark.svg": 1606,
	"./icon-question.svg": 638,
	"./icon-quiz.svg": 2741,
	"./icon-quote-testimonials.svg": 554,
	"./icon-quote.svg": 2064,
	"./icon-rating-star.svg": 2742,
	"./icon-refresh.svg": 2743,
	"./icon-remaining-time.svg": 2744,
	"./icon-replay-accent.svg": 2065,
	"./icon-replay.svg": 2745,
	"./icon-reset-2.svg": 2066,
	"./icon-reset.svg": 2746,
	"./icon-resources.svg": 2747,
	"./icon-review-comments.svg": 2748,
	"./icon-review-indicator.svg": 1607,
	"./icon-review-star.svg": 2067,
	"./icon-reviewed-comments.svg": 2749,
	"./icon-scroll-top.svg": 2750,
	"./icon-search-assignment.svg": 2751,
	"./icon-search-certificate.svg": 2752,
	"./icon-search-code.svg": 2753,
	"./icon-search-course-notes.svg": 2754,
	"./icon-search-course.svg": 2755,
	"./icon-search-dataset.svg": 2756,
	"./icon-search-gif.svg": 2068,
	"./icon-search-lesson.svg": 2757,
	"./icon-search-progress-0.svg": 2758,
	"./icon-search-progress-1.svg": 2759,
	"./icon-search-progress-2.svg": 2760,
	"./icon-search-project.svg": 2761,
	"./icon-search-questions.svg": 2762,
	"./icon-search-quiz.svg": 2763,
	"./icon-search-resource.svg": 2764,
	"./icon-search-time.svg": 2765,
	"./icon-search.svg": 1334,
	"./icon-section-locked.svg": 2766,
	"./icon-send.svg": 2767,
	"./icon-share-score.svg": 2768,
	"./icon-share.svg": 2069,
	"./icon-share2.svg": 2769,
	"./icon-shield.svg": 2770,
	"./icon-shuffle.svg": 2070,
	"./icon-site-linkedin.svg": 1632,
	"./icon-site-search.svg": 2771,
	"./icon-site-twitter.svg": 2772,
	"./icon-snooze.svg": 2773,
	"./icon-sort.svg": 1898,
	"./icon-star.svg": 2774,
	"./icon-stock-down.svg": 2775,
	"./icon-stock-up.svg": 2776,
	"./icon-subtract-unlocked.svg": 2777,
	"./icon-subtract.svg": 2778,
	"./icon-sync.svg": 1974,
	"./icon-text-based-exclamation.svg": 1608,
	"./icon-text-based-play.svg": 1478,
	"./icon-text-based-question.svg": 2779,
	"./icon-text-lesson-type.svg": 2780,
	"./icon-tinymce-bold.svg": 2781,
	"./icon-tinymce-code.svg": 2782,
	"./icon-tinymce-codeblock.svg": 2783,
	"./icon-tinymce-emoji.svg": 2784,
	"./icon-tinymce-italic.svg": 2785,
	"./icon-tinymce-link.svg": 2786,
	"./icon-tinymce-strike.svg": 2787,
	"./icon-tinymce-submit.svg": 2788,
	"./icon-trash.svg": 1899,
	"./icon-trustpilot.svg": 1804,
	"./icon-twitter.svg": 1953,
	"./icon-up-arrow.svg": 1805,
	"./icon-vertical-dots.svg": 2789,
	"./icon-video-cc.svg": 2790,
	"./icon-video-full-screen.svg": 2791,
	"./icon-video-mute.svg": 2792,
	"./icon-video-pause.svg": 2793,
	"./icon-video-play.svg": 2794,
	"./icon-video-rewind.svg": 2795,
	"./icon-video-settings.svg": 2796,
	"./icon-video-transcript.svg": 2797,
	"./icon-video-volume.svg": 2798,
	"./icon-warning-gray.svg": 1844,
	"./icon-warning.svg": 1806,
	"./icon-x.svg": 2799,
	"./icon-youtube.svg": 2800,
	"./linkedin-logo.svg": 3102,
	"./loading-spinner.svg": 1954,
	"./medal.svg": 1845,
	"./minus-icon.svg": 2801,
	"./money-back-guarantee.svg": 1955,
	"./offline.svg": 2071,
	"./player/cc.svg": 3103,
	"./player/fullscreen.svg": 3104,
	"./player/mute.svg": 3105,
	"./player/pause.svg": 3106,
	"./player/play-v2-sm.svg": 3107,
	"./player/play-v2.svg": 3108,
	"./player/play.svg": 3109,
	"./player/polygon.svg": 3110,
	"./player/rewind.svg": 3111,
	"./player/settings.svg": 3112,
	"./player/volume.svg": 3113,
	"./plus-icon.svg": 2802,
	"./projects-guided-unguided.svg": 3114,
	"./projects-instruction.svg": 3115,
	"./projects-quiz.svg": 3116,
	"./rounded-quotes-big.svg": 2803,
	"./rounded-quotes.svg": 3117,
	"./saved.svg": 2072,
	"./select-arrow.svg": 3118,
	"./select-dropdown-arrow.svg": 3119,
	"./signatures/company-linkedin.svg": 3120,
	"./signatures/company-youtube.svg": 3121,
	"./small-icon-download.svg": 2073,
	"./sql.svg": 3122,
	"./stars.svg": 1633,
	"./tech-apache-airflow.svg": 2074,
	"./tech-excel.svg": 2075,
	"./tech-git.svg": 2076,
	"./tech-google-sheets.svg": 2077,
	"./tech-gray-chatgpt.svg": 1427,
	"./tech-gray-excel.svg": 1428,
	"./tech-gray-git.svg": 1429,
	"./tech-gray-google-sheets.svg": 1430,
	"./tech-gray-jupyter.svg": 1431,
	"./tech-gray-multiple.svg": 1432,
	"./tech-gray-other.svg": 1433,
	"./tech-gray-powerbi.svg": 1434,
	"./tech-gray-python.svg": 1435,
	"./tech-gray-r.svg": 1436,
	"./tech-gray-sql.svg": 1437,
	"./tech-gray-tableau.svg": 1438,
	"./tech-gray-theory.svg": 1439,
	"./tech-powerbi.svg": 2078,
	"./tech-python (2).svg": 2079,
	"./tech-python.svg": 2080,
	"./tech-r.svg": 2081,
	"./tech-responsive-apache-airflow.svg": 616,
	"./tech-responsive-artificial-intelligence.svg": 530,
	"./tech-responsive-azure.svg": 617,
	"./tech-responsive-chatgpt.svg": 618,
	"./tech-responsive-copilot.svg": 619,
	"./tech-responsive-data.svg": 620,
	"./tech-responsive-excel.svg": 621,
	"./tech-responsive-git.svg": 622,
	"./tech-responsive-google-cloud.svg": 623,
	"./tech-responsive-google-sheets.svg": 624,
	"./tech-responsive-hugging-face.svg": 625,
	"./tech-responsive-jupyter.svg": 626,
	"./tech-responsive-langchain.svg": 627,
	"./tech-responsive-llama.svg": 628,
	"./tech-responsive-multiple.svg": 629,
	"./tech-responsive-powerbi.svg": 630,
	"./tech-responsive-powerpoint.svg": 631,
	"./tech-responsive-python.svg": 632,
	"./tech-responsive-r.svg": 633,
	"./tech-responsive-shell.svg": 634,
	"./tech-responsive-sql.svg": 635,
	"./tech-responsive-tableau.svg": 636,
	"./tech-responsive-theory.svg": 637,
	"./tech-sql.svg": 2082,
	"./tech-tableau.svg": 2083,
	"./tech-theory.svg": 2084,
	"./tightly-arrow.svg": 3123,
	"./topic-responsive-business analytics.svg": 3124,
	"./topic-responsive-business-analytics.svg": 3125,
	"./topic-responsive-career-development.svg": 3126,
	"./topic-responsive-data-analysis.svg": 3127,
	"./topic-responsive-data-processing.svg": 3128,
	"./topic-responsive-data-science.svg": 3129,
	"./topic-responsive-data-visualization.svg": 3130,
	"./topic-responsive-deep-learning.svg": 3131,
	"./topic-responsive-financial-analysis.svg": 3132,
	"./topic-responsive-machine-learning.svg": 3133,
	"./topic-responsive-mathematics.svg": 3134,
	"./topic-responsive-programming.svg": 3135,
	"./vector.svg": 3136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3055;